import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-search-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-bold font-heading text-white whitespace-nowrap">
                种子搜索
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              最高效的BT资源检索工具，帮助用户快速定位磁力链接与种子文件。支持影视、音乐、软件等全类型资源搜索。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/movie" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">资源分类</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/movie" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">影视资源</Link>
              </li>
              <li>
                <Link to="/category/music" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">音乐资源</Link>
              </li>
              <li>
                <Link to="/category/game" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">游戏资源</Link>
              </li>
              <li>
                <Link to="/category/software" className="text-sm text-foreground-300 hover:text-accent-400 transition-colors">软件资源</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">免责声明</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              本网站仅提供资源搜索技术服务，不存储任何文件内容。请遵守当地法律法规，仅下载和使用版权允许的内容。如有版权问题，请联系我们处理。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2025 种子搜索. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}